import { Hyperlink as CXHyperlink } from '@sanlamcx/react-ui-next-hyperlink';

type Hyperlink = typeof CXHyperlink;
export const Hyperlink: Hyperlink = CXHyperlink;
